module.exports = __webpack_public_path__ + "common/icon-share-button-plain-a4128fba1ba2ec2f7f36536ff727ba6d.svg";